import React from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';

import {FROM_ENTITY, SUBJECT} from '../utils/constants';
import {labels} from '../../../../../../../util/utils';

import Input from '../../../../../../CoreWrappers/Input';
import SelectDropdown from '../../../../../../Common/SelectDropdown/SelectDropdown';
import getAvailableEntityList from '../utils/getAvailableEntityList';
import StyledSubGrid from '../StyledSubGrid';

const GenerateEmail = ({values, errors, handleChange, handleSubmit, handleReset, isFormValid, schema, isLoading}) => {
	const orgChart = useSelector((store) => store.dashboardContext?.orgChart);

	const renderFromEntity = () => {
		const id = FROM_ENTITY;

		const props = {
			id,
			name: id,
			formLabel: labels[id],
			value: values[id] ? [values[id]] : null,
			options: getAvailableEntityList(orgChart),
			onChange: (value) => handleChange(id, value),
			isDisabled: isLoading,
			maxOptionsBeforeScroll: 5,
			menuPlacement: 'bottom'
		};

		if (values[id] !== null) props.defaultValue = [values[id]];

		if (errors[id]) {
			props.showErrorMessage = !!errors[id]?.error;
			props.errorMessage = errors[id]?.message || '';
		}

		return (
			<div className='half-row'>
				<SelectDropdown {...props} />
			</div>
		);
	};

	const renderSubject = () => {
		const id = SUBJECT;

		const props = {
			id,
			disabled: isLoading,
			label: labels[id],
			maxLength: schema[id].maxLength,
			required: true,
			value: values[id],
			onChange: (e) => handleChange(id, e.target.value),
			onBlur: () => handleChange(id, values[id].trim()),
			type: "text"
		};

		if (errors[id]) {
			props.errorMessage = !!errors[id]?.error ? errors[id]?.message?? '' : null;
		}

		return (
			<div className='full-row'>
				<Input {...props} />
			</div>
		);
	};

	return (
		<StyledSubGrid>
			{renderFromEntity()}
			{renderSubject()}
		</StyledSubGrid>
	);
};

GenerateEmail.propTypes = {};

GenerateEmail.defaultProps = {};

export default GenerateEmail;
